<div class="detail-panel">
  <div class="flex justify-end items-center">
    <button (click)="close()" class="button button-primary button-sm" title="Cerrar detalles">
      <i class="fas fa-times" aria-hidden="true"></i>
    </button>
  </div>

  <ul>
    <li>
      <strong>ID:</strong> {{ container?.id }}
    </li>
    <li>
      <strong>Código Oxy:</strong> {{ container?.codOxy }}
    </li>
    <li>
      <strong>Código Red:</strong> {{ container?.codRed }}
    </li>
    <!-- <li>
      <strong>Tipo de Envase:</strong> {{ container?.typePackaging?.name }}
    </li> -->
    <li>
      <strong>Número de Serie:</strong> {{ container?.nroSerie }}
    </li>
    <!-- <li>
      <strong>Cliente:</strong> {{ container?.client?.razonSocial }}
    </li> -->
    <li>
      <strong>Fecha de Fabricación:</strong> {{ container?.dateFabrication }}
    </li>
    <li>
      <strong>Fecha de Prueba Hidráulica:</strong> {{ container?.dateHydraulicTest }}
    </li>
    <li>
      <strong>Tara:</strong> {{ container?.tara }}
    </li>
    <li>
      <strong>Estado:</strong> {{ container?.disabled ? 'Deshabilitado' : 'Habilitado' }}
    </li>
  </ul>

  <div class="flex justify-center mt-6 space-x-4">
    <button (click)="close()" class="button button-outlined-primary">Cancelar</button>
    <a [routerLink]="['/containers/update', container?.id]" class="button button-primary">Editar</a>
  </div>
</div>
  